const React = require('react');
const AppIcon = require('../icons/Lunu');

module.exports = (props) => {
  const [dots, setDots] = React.useState('');

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => (prevDots.length < 3 ? prevDots + '.' : ''));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="rlv h100vh ovH layout fhaCenter aiCenter">
      <div className="abs st57 sl100">
        <div className="layoutRow fhaS fvaC tdN olN dn o70:h rlv">
          <AppIcon className="w128 mr20 rlv c0"/>
          <div className="rlv">
            <div className="abs svl layoutRow fhaC fvaC">
              <div
                className="c5B47FF fw3 f16 lh30 lts0em"
              >Console
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="f23">
          <p className="">No network connection</p>
          <div className="w100% layout fhaCenter">
            <svg
              width="86"
              height="86"
              viewBox="0 0 86 86"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="dB rlv"
            >
              <circle cx="43" cy="43" r="43" fill="#121212"/>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.9752 22.7057L61.5181 60.2486C62.4591 61.1896 62.4591 62.7096 61.5181 63.6024C60.5771 64.5434 59.0571 64.5434 58.1161 63.6024L42.7467 48.2329C39.3929 48.3053 36.0391 49.3187 33.1679 51.3454C31.7926 52.3347 29.9348 52.214 28.7525 51.0318L28.7284 51.0076C27.2807 49.56 27.3772 47.1231 29.0421 45.9167C31.4066 44.2036 34.0124 42.9972 36.7388 42.2734L31.3583 36.8929C28.5836 38.0269 25.9296 39.5711 23.5168 41.5495C22.1898 42.6594 20.2354 42.5388 19.0049 41.3083C17.5813 39.8847 17.6778 37.5202 19.2462 36.2414C21.4177 34.456 23.7822 32.9842 26.2191 31.7778L20.5732 26.1077C19.6322 25.1667 19.6322 23.6467 20.5732 22.7057C21.024 22.2539 21.636 22 22.2742 22C22.9124 22 23.5244 22.2539 23.9752 22.7057ZM66.9952 41.3082C65.7646 42.5388 63.7862 42.6353 62.435 41.5254C56.7167 36.8446 49.6955 34.5525 42.7226 34.6248L36.4735 28.3757C46.9691 26.5179 58.092 29.1478 66.7539 36.2414C68.3222 37.5202 68.4187 39.8847 66.9952 41.3082ZM50.8777 42.8041C53.0251 43.5279 55.0759 44.5654 56.9579 45.9407C58.2367 46.8575 58.5745 48.5224 57.9954 49.9218L50.8777 42.8041ZM47.6928 56.2192C44.7492 54.6991 41.2265 54.6991 38.2588 56.2192C36.8353 56.9672 36.5699 58.9215 37.7039 60.0555L41.2507 63.6023C42.1916 64.5433 43.7117 64.5433 44.6527 63.6023L48.1995 60.0555C49.3817 58.9215 49.1405 56.9672 47.6928 56.2192Z"
                fill="white"
              />
            </svg>
          </div>
          <p className="ml10">Trying to reconnect{dots}</p>
        </div>
      </div>
    </div>
  );
};
